import {SignType} from "@modals/sign/sign.types";

export interface IAddEditValuePageConfiguration {
    title: string,
	type?: string,
	defaultValue?: string,
    handleSave?: (value: any, SignType?: SignType) => void,
    handleDismiss?: () => void;
    url?: string,
    placeholder?: string,
    values?: any[],
    redirectTo?: string
}

let configuration: IAddEditValuePageConfiguration | undefined = undefined;

export function setConfiguration(newConfiguration: IAddEditValuePageConfiguration) {
    configuration = newConfiguration;
}

export function getConfiguration(): IAddEditValuePageConfiguration | undefined {
    return configuration;
}
